import { RootStore } from '../rootStore';
import { FormikHelpers } from 'formik';
import { FormStore } from 'stores/formStore';

import { ADMIN_INSTITUTION, ADMIN_INSTITUTIONS } from 'api/endpoints';
import { observable, action } from 'mobx';
import { SingleValueResponse } from 'common/interfaces';

import { FinancialInstitution } from 'pages/Accounts/Edit/components/ExternalProducts/model';

export class BackofficeInstitutions extends FormStore<FinancialInstitution> {
  rootStore: RootStore;
  @observable institutions: FinancialInstitution[] | null;
  @observable editOpen = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
    this.rootStore = rootStore;
    this.institutions = null;
  }

  @action setEditOpen = (open: boolean) => (this.editOpen = open);
  @action clearData = () => (this.data = null);

  @action
  fetchInstitutions = async () => {
    const response = await this.rootStore.stores.apiStore.get<FinancialInstitution[]>(ADMIN_INSTITUTIONS);
    if (response?.data) {
      this.institutions = response.data;
    }
  };

  @action
  fetchData = async (id: string) => {
    const response = await this.rootStore.stores.apiStore.get<FinancialInstitution>(ADMIN_INSTITUTION(id));
    if (response?.data) {
      this.data = response.data;
    }
  };

  @action
  handleSubmit = async (values: FinancialInstitution, formikHelpers?: FormikHelpers<FinancialInstitution>) => {
    this.rootStore.stores.uiStore.setLoading(true);
    const success = await this.submitData(
      ADMIN_INSTITUTIONS,
      { ...values, id: values.id === '' ? undefined : values.id },
      {
        validationPrefixDepth: 1,
        formikHelpers,
        reset: false,
        singleValueResponse: true,
      },
    );
    this.rootStore.stores.uiStore.setLoading(false);
    if (success) {
      this.setEditOpen(false);
      this.clearData();
      this.institutions = null;
      await this.fetchInstitutions();
    }
    return success;
  };

  @action
  deleteInstitution = async (id: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.delete<SingleValueResponse<boolean>>(ADMIN_INSTITUTION(id));
    if (response?.data?.value) {
      this.institutions = null;
      await this.fetchInstitutions();
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };
}
